import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx } from "vue"

const _hoisted_1 = { key: 1 }
const _hoisted_2 = { class: "element-box" }
const _hoisted_3 = { class: "row align-items-center justify-content-between" }
const _hoisted_4 = { class: "mt-3" }
const _hoisted_5 = { class: "customExcelExport" }
const _hoisted_6 = { class: "table-responsive overflow-auto pt-4 mb-3" }
const _hoisted_7 = { class: "table table-striped" }
const _hoisted_8 = { class: "text-end" }
const _hoisted_9 = { class: "text-end" }
const _hoisted_10 = { class: "text-end" }
const _hoisted_11 = { class: "text-end" }
const _hoisted_12 = { class: "text-end" }
const _hoisted_13 = { class: "text-end" }
const _hoisted_14 = { class: "text-end" }
const _hoisted_15 = { class: "text-end" }
const _hoisted_16 = { class: "text-end" }
const _hoisted_17 = { class: "text-end" }
const _hoisted_18 = { class: "text-end" }
const _hoisted_19 = { class: "text-end" }
const _hoisted_20 = { class: "text-end" }
const _hoisted_21 = { class: "text-end" }
const _hoisted_22 = { class: "text-end" }
const _hoisted_23 = { class: "text-end" }
const _hoisted_24 = { class: "text-end" }
const _hoisted_25 = { class: "text-end" }
const _hoisted_26 = { class: "text-end" }
const _hoisted_27 = { class: "text-end" }
const _hoisted_28 = { class: "text-end" }
const _hoisted_29 = { class: "text-end" }
const _hoisted_30 = { class: "text-end" }
const _hoisted_31 = { class: "text-end" }
const _hoisted_32 = { class: "text-end" }
const _hoisted_33 = { class: "text-end" }
const _hoisted_34 = { class: "text-end" }
const _hoisted_35 = { class: "text-end" }

import analyticsService from '@/api/Analytics';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import {CloseToast, ErrorToast} from '@/components/VueToast';
import {getAllUnemployedDropdown, getOfficeDropdown} from '@/shared/dropdowns';
import {downloadFile} from '@/shared/functions';
import Search from '@/views/App/Analytics/Retrospective/AssistedLivingCoaching/Search.vue';
import {onMounted, ref} from 'vue';
import ExcelExportButton from "@/components/ExcelExportButton.vue";
import BackButton from "@/components/button/BackButton.vue";

interface ICoachingList {
  retrospectiveData: IRetrospectiveCoaching[],
  pagination: IPagination
}


export interface IRetrospectiveCoaching {
  id: number;
  status: string;
  unemployedFirstName: string;
  unemployedLastName: string;
  location: string;
  startDate: string;
  endDate: string;
  maxUnits: number;
  potentialUnitsUpToDate: number;
  unitsDoneUpToDate: number;
  specialistPercentUpToDate: number;
  supervisorPercentUpToDate: number;
  specialistMaxUnits: number;
  supervisorMaxUnits: number;
  specialistUnitsDoneUpToDate: number;
  supervisorUnitsDoneUpToDate: number;
  specialistTotalUnitsLeft: number;
  supervisorTotalUnitsLeft: number;
  specialistUnitsLeftUpToDate: number;
  supervisorUnitsLeftUpToDate: number;
  specialistBudgetDifference: number;
  supervisorBudgetDifference: number;
  budgetDifferenceFilter: number;
  weeksDoneUpToDate: number;
  maxWeeks: number;
  weeksLeft: number;
  unitsForSpecialistInWeek: number;
  unitsForSupervisorInWeek: number;
  weeksDonePercent: number;
  unitsInWeek: number;
  unitsDone: number;
  unitsDonePercent: number;
  percentageDistribution: number;
  specialist: string | null;
  unitsDoneBySpecialist: number;
  supervisor: string | null;
  unsignedUnits: number;
  documentStatus: string;
  lastUnit: string | null;
}

interface IFilters {
  officeIds?: number[];
  toDate: string;
  page: number,
  limit: number,
}

interface IPagination {
  total_pages: number;
  current_page: number;
  items_per_page?: number;
  total_items?: number;
}


// ---------- State ----------


export default /*@__PURE__*/_defineComponent({
  __name: 'List',
  setup(__props) {

const now = new Date();

const day = String(now.getDate()).padStart(2, '0');
const month = String(now.getMonth() + 1).padStart(2, '0');
const year = now.getFullYear();

// ---------- Types ----------

const filters = ref<IFilters>({
  officeIds: [],
  toDate: `${day}.${month}.${year}`,
  page: 1,
  limit: 10,
});

const coachingList = ref<ICoachingList>();
const officeDropdown = ref([]);
const unemployedDropdown = ref([]);
const isSearching = ref(false);
const isLoaded = ref(false);
const isExcelLoaded = ref(false);

async function getExcelExport() {
  await downloadFile('/analytics/retrospective-excel-export/assisted-living-coaching',
      undefined,
      {
        ...filters.value,
        'officeIds[]': filters.value.officeIds,
      },
      false,
      'GET',
      isExcelLoaded
  )
}

async function getCoachingList(
    page = 1,
    perPage?: number,
    passedFilters?: IFilters
) {
  CloseToast();

  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = coachingList.value?.pagination?.items_per_page;

  try {
    const {data} = await analyticsService.getRetrospectiveAssistedLivingCoachingList({
      ...(passedFilters ? passedFilters : filters.value),
      page: page,
      limit: perPage ?? perPageRes!,
    });

    console.log(data)

    coachingList.value = data.data;
    isSearching.value = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

const handleDropdownSearch = async (
    searchTerm: string,
    type: string
) => {
  if (searchTerm.length < 3) return; //

  const filters = {
    searchTerm: searchTerm,
    searchTermFor: type
  }

  await getAllUnemployedDropdown(
      unemployedDropdown,
      'lastName',
      'lastName',
      filters
  )
};

const handleClearDropdown = () => {
  unemployedDropdown.value = [];
}


onMounted(async () => {
  await Promise.all([
    getOfficeDropdown(officeDropdown),
    getCoachingList()
  ]);

  isLoaded.value = true;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PageTemplate, null, {
    default: _withCtx(() => [
      (!isLoaded.value)
        ? (_openBlock(), _createBlock(Loader, { key: 0 }))
        : (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(BackButton, {
              label: _ctx.$t('general.button.back'),
              to: { name: 'analyticsHome' },
              marginBottom: "5"
            }, null, 8, ["label"]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "d-flex justify-content-between" }, [
              _createElementVNode("h6", { class: "element-header" }, " Retrospektive ")
            ], -1)),
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "form-header mb-4" }, "Betreutes Wohnen", -1)),
              _createVNode(Search, {
                filters: filters.value,
                loading: isSearching.value,
                officeDropdown: officeDropdown.value,
                unemployedDropdown: unemployedDropdown.value,
                onSearch: getCoachingList,
                onDropdownFetch: handleDropdownSearch,
                onClearDropdown: handleClearDropdown
              }, null, 8, ["filters", "loading", "officeDropdown", "unemployedDropdown"]),
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(PerPage, {
                    values: [10, 25, 50, 100],
                    "onUpdate:perPage": getCoachingList
                  }),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(ExcelExportButton, {
                      label: _ctx.$t('general.excel_export'),
                      loading: isExcelLoaded.value,
                      onClick: getExcelExport
                    }, null, 8, ["label", "loading"])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("table", _hoisted_7, [
                  _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", null, "Status"),
                      _createElementVNode("th", null, "Kunden"),
                      _createElementVNode("th", null, "Standort"),
                      _createElementVNode("th", null, "Start"),
                      _createElementVNode("th", null, "Ende"),
                      _createElementVNode("th", { class: "text-end" }, "Gesamtbudget"),
                      _createElementVNode("th", { class: "text-end" }, "Tatsächliches SOLL HEUTE"),
                      _createElementVNode("th", { class: "text-end" }, "IST GESAMT"),
                      _createElementVNode("th", { class: "text-end" }, "Anteil FK"),
                      _createElementVNode("th", { class: "text-end" }, "Anteil AK"),
                      _createElementVNode("th", { class: "text-end" }, "SOLL FK Gesamtbudget"),
                      _createElementVNode("th", { class: "text-end" }, "SOLL AK Gesamtbudget"),
                      _createElementVNode("th", { class: "text-end" }, "IST FK 70"),
                      _createElementVNode("th", { class: "text-end" }, "IST AK 30"),
                      _createElementVNode("th", { class: "text-end" }, "Rest FK Budget"),
                      _createElementVNode("th", { class: "text-end" }, "Rest AK Budget"),
                      _createElementVNode("th", { class: "text-end" }, "Rest FK tats. SOLL"),
                      _createElementVNode("th", { class: "text-end" }, "Rest AK tats. SOLL"),
                      _createElementVNode("th", { class: "text-end" }, "Differenz FK Budget"),
                      _createElementVNode("th", { class: "text-end" }, "Differenz AK Budget"),
                      _createElementVNode("th", { class: "text-end" }, "Filter AK"),
                      _createElementVNode("th", { class: "text-end" }, "Verbrauchte Wochen"),
                      _createElementVNode("th", { class: "text-end" }, "Gesamtwochenanzahl"),
                      _createElementVNode("th", { class: "text-end" }, "Restwochen"),
                      _createElementVNode("th", { class: "text-end" }, "ToDo FK pro Woche"),
                      _createElementVNode("th", { class: "text-end" }, "ToDo AK pro Woche"),
                      _createElementVNode("th", { class: "text-end" }, "Relativer Anteil an Wochen"),
                      _createElementVNode("th", { class: "text-end" }, "FLS PRO WOCHE"),
                      _createElementVNode("th", { class: "text-end" }, "STAND"),
                      _createElementVNode("th", { class: "text-end" }, "STAND %"),
                      _createElementVNode("th", { class: "text-end" }, "PROZENTUALE VERTEILUNG"),
                      _createElementVNode("th", { class: "text-end" }, "FACHKRAFT 1"),
                      _createElementVNode("th", { class: "text-end" }, "FACHKRAFT 1 UE"),
                      _createElementVNode("th", { class: "text-end" }, "BETREUER 2"),
                      _createElementVNode("th", { class: "text-end" }, "BETREUER 2 UE"),
                      _createElementVNode("th", { class: "text-end" }, "UN FEHLT"),
                      _createElementVNode("th", { class: "text-end" }, "EINFÜHRUNGSUNTERLAGEN"),
                      _createElementVNode("th", { class: "text-end" }, "LETZTER TERMIN")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", null, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(coachingList.value?.retrospectiveData, (coaching) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: coaching.id
                      }, [
                        _createElementVNode("td", null, _toDisplayString(coaching?.status), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.unemployedFirstName) + " " + _toDisplayString(coaching?.unemployedLastName), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.location) + "}", 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.startDate), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching?.endDate), 1),
                        _createElementVNode("td", _hoisted_8, _toDisplayString(coaching?.maxUnits), 1),
                        _createElementVNode("td", _hoisted_9, _toDisplayString(coaching.potentialUnitsUpToDate), 1),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(coaching.unitsDoneUpToDate), 1),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(coaching.specialistPercentUpToDate), 1),
                        _createElementVNode("td", _hoisted_12, _toDisplayString(coaching.supervisorPercentUpToDate), 1),
                        _createElementVNode("td", _hoisted_13, _toDisplayString(coaching.specialistMaxUnits), 1),
                        _createElementVNode("td", _hoisted_14, _toDisplayString(coaching.supervisorMaxUnits), 1),
                        _createElementVNode("td", _hoisted_15, _toDisplayString(coaching.specialistUnitsDoneUpToDate), 1),
                        _createElementVNode("td", _hoisted_16, _toDisplayString(coaching.supervisorUnitsDoneUpToDate), 1),
                        _createElementVNode("td", _hoisted_17, _toDisplayString(coaching.specialistTotalUnitsLeft), 1),
                        _createElementVNode("td", _hoisted_18, _toDisplayString(coaching.supervisorTotalUnitsLeft), 1),
                        _createElementVNode("td", _hoisted_19, _toDisplayString(coaching.specialistUnitsLeftUpToDate), 1),
                        _createElementVNode("td", _hoisted_20, _toDisplayString(coaching.supervisorUnitsLeftUpToDate), 1),
                        _createElementVNode("td", _hoisted_21, _toDisplayString(coaching.specialistBudgetDifference), 1),
                        _createElementVNode("td", _hoisted_22, _toDisplayString(coaching.supervisorBudgetDifference), 1),
                        _createElementVNode("td", _hoisted_23, _toDisplayString(coaching.budgetDifferenceFilter), 1),
                        _createElementVNode("td", _hoisted_24, _toDisplayString(coaching.weeksDoneUpToDate), 1),
                        _createElementVNode("td", _hoisted_25, _toDisplayString(coaching.maxWeeks), 1),
                        _createElementVNode("td", _hoisted_26, _toDisplayString(coaching.weeksLeft), 1),
                        _createElementVNode("td", _hoisted_27, _toDisplayString(coaching.unitsForSpecialistInWeek), 1),
                        _createElementVNode("td", _hoisted_28, _toDisplayString(coaching.unitsForSupervisorInWeek), 1),
                        _createElementVNode("td", _hoisted_29, _toDisplayString(coaching.weeksDonePercent), 1),
                        _createElementVNode("td", _hoisted_30, _toDisplayString(coaching.unitsInWeek), 1),
                        _createElementVNode("td", _hoisted_31, _toDisplayString(coaching.unitsDone), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(coaching.unitsDonePercent), 1),
                        _createElementVNode("td", _hoisted_33, _toDisplayString(coaching.percentageDistribution), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching.specialist), 1),
                        _createElementVNode("td", _hoisted_34, _toDisplayString(coaching.unitsDoneBySpecialist), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching.supervisor), 1),
                        _createElementVNode("td", _hoisted_35, _toDisplayString(coaching.unsignedUnits), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching.documentStatus), 1),
                        _createElementVNode("td", null, _toDisplayString(coaching.lastUnit), 1)
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              (coachingList.value?.pagination?.total_pages ?? 0 > 1)
                ? (_openBlock(), _createBlock(Pagination, {
                    key: 0,
                    totalPages: coachingList.value?.pagination?.total_pages,
                    currentPage: coachingList.value?.pagination?.current_page,
                    totalItems: coachingList.value?.pagination?.total_items,
                    perPage: coachingList.value?.pagination?.items_per_page,
                    onPagechanged: getCoachingList
                  }, null, 8, ["totalPages", "currentPage", "totalItems", "perPage"]))
                : _createCommentVNode("", true)
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})